export const FETCH_CREATE_DOCUMENT_FOLDER_REQUEST = 'FETCH_CREATE_DOCUMENT_FOLDER_REQUEST'
export const FETCH_CREATE_DOCUMENT_FOLDER_SUCCESS = 'FETCH_CREATE_DOCUMENT_FOLDER_SUCCESS'
export const FETCH_CREATE_DOCUMENT_FOLDER_FALUIRE = 'FETCH_CREATE_DOCUMENT_FOLDER_FALUIRE'
